import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage } from '@angular/fire/storage';

import { async } from '@angular/core/testing';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-createplan',
  templateUrl: './createplan.component.html',
  styleUrls: ['./createplan.component.css']
})
export class CreateplanComponent implements OnInit {

  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  url:string;
  categories:string[] = ['Home Broadband', 'Corporate Broadband'];
  cat:string = '';
  id2:string='';
  imgUploaded:boolean=false;

  
  exampleForm: FormGroup;
  validation_messages = {
    'pname': [
      { type: 'required', message: 'Plan Name is required.' }
    ],
    'speed': [
      { type: 'required', message: 'Speed is required.' }
    ],
    'data': [
      { type: 'required', message: 'High Speed Data is required.' }
    ],
    'exspeed': [
      { type: 'required', message: 'Exhausted Data speed is required.' }
    ],
    'price': [
      { type: 'required', message: 'Price is required.' }
    ],
    'category': [
      { type: 'required', message: 'Category is required.' },
    ]
  };

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router, private ar: ActivatedRoute,
    public firebaseService: FirebaseService,
    private afs: AngularFireStorage) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(){
    this.exampleForm = this.fb.group({
      pname: ['', Validators.required ],
      data:['', Validators.required ],
      speed:['', Validators.required ],
      exspeed:['', Validators.required ],
      price: ['', Validators.required ],
      category: ['', Validators.required ]
    });
  }
  
  resetFields(){
    this.exampleForm = this.fb.group({
      pname: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      category: new FormControl('', Validators.required),
      data: new FormControl('', Validators.required),
      speed: new FormControl('', Validators.required),
      exspeed: new FormControl('', Validators.required)
    });
  }

  upload(event){
    this.id2= Math.random().toString(36).substring(2);
    this.ref=this.afs.ref(this.id2);
    this.task= this.ref.put(event.target.files[0]);
    this.task.percentageChanges().subscribe(res=>{
      if(res==100){
        this.afs.ref(this.id2).getDownloadURL().subscribe(result=>{
          this.url=result;
          this.exampleForm.patchValue({
            imgurl: result
          });
          this.imgUploaded=true;
        })
      }
    });
  }
  
  addNewPlan(value){
    // if(!this.imgUploaded){
    //   alert("Please let the image Upload");
    // }
      this.firebaseService.createPlan(value);
      this.resetFields();
      this.router.navigateByUrl('adminbackend/allplans');
    }
}


//copy of previous working code


// import { Component, OnInit } from '@angular/core';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
// import { MatDialog } from '@angular/material/dialog';
// import { Router, ActivatedRoute } from '@angular/router';
// import { FirebaseService } from 'src/app/services/firebase.service';
// import { AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage } from '@angular/fire/storage';
// import { Observable } from 'rxjs';
// import { async } from '@angular/core/testing';
// import { MatSelect } from '@angular/material/select';

// @Component({
//   selector: 'app-createplan',
//   templateUrl: './createplan.component.html',
//   styleUrls: ['./createplan.component.css']
// })
// export class CreateplanComponent implements OnInit {

//   ref: AngularFireStorageReference;
//   task: AngularFireUploadTask;
//   url:string;
//   categories:string[] = ['Broadband', 'Fiber', 'DTH', 'Mobile Prepaid', 'Mobile Postpaid'];
//   cat:string = '';
//   id2:string='';
//   imgUploaded:boolean=false;

  
//   exampleForm: FormGroup;
//   validation_messages = {
//     'pname': [
//       { type: 'required', message: 'Plan Name is required.' }
//     ],
//     'price': [
//       { type: 'required', message: 'Price is required.' }
//     ],
//     'category': [
//       { type: 'required', message: 'Category is required.' },
//     ]
//   };

//   constructor(
//     private fb: FormBuilder,
//     public dialog: MatDialog,
//     private router: Router, private ar: ActivatedRoute,
//     public firebaseService: FirebaseService,
//     private afs: AngularFireStorage) { }

//   ngOnInit(): void {
//     this.createForm();
//   }

//   createForm(){
//     this.exampleForm = this.fb.group({
//       pname: ['', Validators.required ],
//       price: ['', Validators.required ],
//       category: ['', Validators.required ],
//       id: ['', Validators.required],
//       imgurl: ['', Validators.required]
//     });
//   }
  
//   resetFields(){
//     this.exampleForm = this.fb.group({
//       pname: new FormControl('', Validators.required),
//       price: new FormControl('', Validators.required),
//       category: new FormControl('', Validators.required),
//       id: new FormControl('', Validators.required),
//       imgurl: new FormControl('', Validators.required)
//     });
//   }

//   upload(event){
//     this.id2= Math.random().toString(36).substring(2);
//     this.exampleForm.patchValue({
//       id: this.id2
//     })
//     this.ref=this.afs.ref(this.id2);
//     this.task= this.ref.put(event.target.files[0]);
//     this.task.percentageChanges().subscribe(res=>{
//       if(res==100){
//         this.afs.ref(this.id2).getDownloadURL().subscribe(result=>{
//           this.url=result;
//           this.exampleForm.patchValue({
//             imgurl: result
//           });
//           this.imgUploaded=true;
//         })
//       }
//     });
//   }
  
//   addNewPlan(value){
//     if(!this.imgUploaded){
//       alert("Please let the image Upload");
//     }
//     else {
      
//       this.firebaseService.createPlan(value, this.id2, this.url)
//       .then(
//         res => {
//           this.resetFields();
//           this.imgUploaded=false;
//           this.router.navigateByUrl('adminbackend/allplans');
//         }
//       )
//     }
//   }
// }
